import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  HostBinding,
  Input,
  TemplateRef,
  ViewEncapsulation,
} from '@angular/core';
import { PrimeTemplate } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

@Component({
  selector: 'osp-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  standalone: true,
  providers: [PrimeTemplate],
  imports: [ConfirmDialogModule, CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  styleUrl: './confirm-dialog.component.scss',
})
export class ConfirmDialogComponent {
  @HostBinding('class') protected hostClass = 'osp-confirm-dialog';

  @ContentChild(TemplateRef) template!: TemplateRef<unknown>;

  @Input() key?: string;
}
